import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { AuthService } from './../../api/auth.service';
import { CreateNewModalComponent } from '../../modal/create-new-modal/create-new-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MustMatch } from './must-match.validator';


@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  securityQuestionsForm: FormGroup;
  createNewPasswordForm: FormGroup;
  submitted = false;
  step: number;
  modalRef: any;
  userid: any;
  public checkUserAvailabilityStatus : boolean;

  security_q1_ans: true;
  security_q2_ans: true;
  security_q3_ans: true;
  security_q4_ans: true;


  constructor(
    private router: Router,
    private formBuilder: FormBuilder, private modalService: NgbModal,
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.step = 1;
    this.forgotPasswordForm  =  this.formBuilder.group({
      username: ['', Validators.required]
    });
    this.securityQuestionsForm  =  this.formBuilder.group({
      security_q1_ans: ['', Validators.required],
      security_q2_ans: ['', Validators.required],
      security_q3_ans: ['', Validators.required],
      security_q4_ans: ['', Validators.required],
      user_id : ['']
    });
    this.createNewPasswordForm  =  this.formBuilder.group({
      password: ['', Validators.required],
      confirmPassword: ['', Validators.required],
      user_id : ['']
    }, {
      validator: MustMatch('password', 'confirmPassword')
    });
  }

  // convenience getter for easy access to form fields
  get f1() { return this.forgotPasswordForm.controls; }
  get f2() { return this.securityQuestionsForm.controls; }
  get f3() { return this.createNewPasswordForm.controls; }

  dateConvert(str: string | number | Date) {
    const date = new Date(str),
    mnth = ('0' + (date.getMonth() + 1)).slice(-2),
    day = ('0' + date.getDate()).slice(-2);
    return [mnth, day, date.getFullYear()].join('/');
  }
  continue() {
    this.submitted = false;
    if (this.step === 1) {
      console.log(this.forgotPasswordForm.value);
      if (this.forgotPasswordForm.invalid) {
        this.submitted = true;
        return;
      } else {
        this.authService.checkUserAvailability( this.forgotPasswordForm.value ).subscribe(res => {
          this.userid = res.userId;
          this.step ++;
        }, error => {
          this.checkUserAvailabilityStatus = false;
        });
      }
    } else if (this.step === 2) {
      this.securityQuestionsForm.value.user_id = this.userid;
      this.security_q1_ans= true;
      this.security_q2_ans= true;
      this.security_q3_ans= true;
      this.security_q4_ans= true;

      console.log(this.securityQuestionsForm.value);
      if (this.securityQuestionsForm.invalid) {
        this.submitted = true;
        
        return;
      } else {
        this.securityQuestionsForm.value.security_q2_ans = this.dateConvert(this.securityQuestionsForm.value.security_q2_ans);
        this.authService.checkSecurityQuestins( {'data' : this.securityQuestionsForm.value}).subscribe(res => {
          this.step ++;
        }, error => {
          this.security_q1_ans= error.error.error.security_q1_ans;
          this.security_q2_ans= error.error.error.security_q2_ans;
          this.security_q3_ans= error.error.error.security_q3_ans;
          this.security_q4_ans= error.error.error.security_q4_ans;

        });
      }
    } else if (this.step === 3) {
      this.createNewPasswordForm.value.user_id = this.userid;
      console.log(this.forgotPasswordForm.value);
      if (this.createNewPasswordForm.invalid) {
        this.submitted = true;
        return;
      } else {
        this.authService.changePassword(  this.createNewPasswordForm.value ).subscribe(res => {
          this.modalRef = this.modalService.open(CreateNewModalComponent);
          this.modalRef.componentInstance.my_modal_content = 'password changed please login';
          this.modalRef.result.then((data: any) => {
          this.router.navigateByUrl('/login');
        });
          this.step ++;
        }, error => {
          this.modalRef = this.modalService.open(CreateNewModalComponent);
          this.modalRef.componentInstance.my_modal_content = 'something went wrong';
          this.modalRef.result.then((data: any) => {
          this.router.navigateByUrl('/forgot-password');
        });
        });
      }
    }
    this.submitted = false;
  }

}
